import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Select from 'components/Select';
import Tr from 'translations/Translations';
import typeValues, { VARIANT_CODE } from '../constants/criteria.variants'
import TextInput from 'components/TextInput';
import criteriumVariant, { CRYTERIUM_TYPE } from '../constants/criterium.type'
import getObjectValue from 'libs/getObjectValue';
import InputLimits from 'constants/InputLimits';
import {isDemandPreparing} from 'libs/getDemandStatus';

const limits = InputLimits.procedure

const style = theme => ({
	root: {

	}
})

function OtherCriteriaFields({
	classes,
	formikProps,
	edit,
	selectedItems,
	initValues,
}) {

	const type = getObjectValue("type", formikProps.values, '')

	const setRepeatValue = (direction, fieldValue) => {
		formikProps.setFieldValue("uiType", VARIANT_CODE.NUMBER)
		formikProps.setFieldValue("calculation", true)
		formikProps.setFieldValue("direction", direction)
		if (fieldValue) formikProps.setFieldValue("uom", fieldValue)
	}

	useEffect(() => {
		if (!edit) {
			if (type === CRYTERIUM_TYPE.PAYMENT) setRepeatValue("ASCENDING", "TG")
			else if (type === CRYTERIUM_TYPE.GUARANTEE) setRepeatValue("ASCENDING", "MS")
			else if (type === CRYTERIUM_TYPE.TIME_LIMIT) setRepeatValue("DESCENDING", "TG")
			else if (type === CRYTERIUM_TYPE.PRICE) setRepeatValue("DESCENDING", "PLN")
			else formikProps.setFieldValue("uiType", VARIANT_CODE.TEXT);
		}
		// eslint-disable-next-line
	}, [type])

	const typeElements = criteriumVariant.reduce((acc, item) => {
		if (item.value === CRYTERIUM_TYPE.OTHER) return [...acc, item];
		if (initValues !== undefined) {
			if (item.value === initValues.type) {
				return [...acc, item]
			}
		}
		if (selectedItems.find(x => x.type === item.value)) {
			return acc;
		}
		return [...acc, item]
	}, [])

	return (
		<GridBlock column>
			<Select
				id={'type'}
				formikProps={formikProps}
				items={typeElements}
				label={Tr('criterium')}
				disabled={formikProps.values.type === CRYTERIUM_TYPE.PRICE || (!isDemandPreparing() && !!initValues)}
				required
			/>
			{(formikProps.values.type === CRYTERIUM_TYPE.OTHER ||
				formikProps.values.type === CRYTERIUM_TYPE.PRICE
			) &&
				<TextInput
					label={Tr('criterion_name')}
					id='otherName'
					required={formikProps.values.type !== CRYTERIUM_TYPE.PRICE}
					formikProps={formikProps}
					limit={limits.criteriaSection.NAME}
					disabled={!isDemandPreparing() && !!initValues}
				/>
			}
			{(formikProps.values.uiType !== undefined &&
				formikProps.values.type !== CRYTERIUM_TYPE.PRICE
			) &&
				<TextInput
					label={Tr('description')}
					id='description'
					formikProps={formikProps}
					multiline
				/>
			}
			<Select
				id={'uiType'}
				formikProps={formikProps}
				items={typeValues}
				label={Tr('type')}
				disabled={type === CRYTERIUM_TYPE.PRICE || (!isDemandPreparing() && !!initValues)}
				required
			/>
		</GridBlock>
	)
}

OtherCriteriaFields.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(OtherCriteriaFields);